module.exports = __webpack_public_path__ + "img/dang3.16ef3794.png";